import React, {useContext, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  cancelCollegeCourse,
  deleteCollegeCourse,
  newCollegeCourse,
  scrolledToCollegeCourse,
} from 'shared/portfolio/actions/college-courses';
import {Store} from 'src/types/store';

import {PlatformContext} from 'src/components/PlatformContext';
import CollegeCourseFormWrapper, {
  CollegeCourse,
} from 'shared/portfolio/components/courses/college-courses/college-course-form-wrapper';
import CollegeCourseForm from 'shared/portfolio/components/courses/college-courses/college-course-form';
import PortfolioFormFooter from 'src/components/PortfolioFormFooter';

interface Props {
  course: CollegeCourse;
}

const CollegeCourseFormCard = ({course}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const platformContext = useContext(PlatformContext);
  const dispatch = useDispatch();
  const currentInstitution = useSelector((state: Store) => state.student.currentInstitution);

  useEffect(() => {
    if (course.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToCollegeCourse(course._id));
      }, 550);
    }
  }, [dispatch, course.scrollTo, course._id]);

  return (
    <div id={course._id} className="portfolio-form-card">
      <h4 ref={ref} className="portfolio-sections add-edit-header">
        {course.new ? 'Add' : 'Edit'} Course
      </h4>
      <CollegeCourseFormWrapper
        initialValues={{
          ...course,
          institution: {
            name: course.institution.name,
            parentId: course.institution.parentId,
            type: course.institution.type,
            _id: course.institution._id,
          },
        }}
      >
        <CollegeCourseForm />
        <PortfolioFormFooter
          _id={course._id}
          onCancel={() => dispatch(cancelCollegeCourse(course))}
          nativeAlertForDelete={platformContext.isIonic}
          onDelete={() => dispatch(deleteCollegeCourse(course._id))}
          onAddAnother={() => dispatch(newCollegeCourse(currentInstitution))}
          formName="portfolio courses course-form"
        />
      </CollegeCourseFormWrapper>
    </div>
  );
};

export default CollegeCourseFormCard;
